import { IStepOption } from "ngx-ui-tour-md-menu";

export interface IstepOptionCustom extends IStepOption {
    gif?: string;
    action?(): void;
    alert?: {
        title: string;
        content: string;
    },
    gaEvent?: string;
    tourRef: ETourRef;
}

export enum ETourRef {
    MENU = 'menu',
    RESULTADOS = 'tour-resultados',
    SEND_QUOTE = 'tour-send-quote'
}